var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestingQualityAssurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6385 11.3781H16.3107C15.6895 11.3781 15.186 10.8745 15.186 10.2534V6.64903C15.186 6.0279 15.6895 5.52439 16.3107 5.52439H17.6385",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.186 8.45117H17.2891",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4302 5.52439H22.3772C21.569 5.52439 20.9138 6.17955 20.9138 6.98781C20.9138 7.79607 21.569 8.45122 22.3772 8.45122H22.484C23.2921 8.45122 23.9474 9.10637 23.9474 9.91464C23.9474 10.7229 23.2921 11.3781 22.484 11.3781H20.9138",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9138 5.52439V11.3781",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40479 5.52441H12.4231",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5205 5.52439V11.3781",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0115 5.52441H30.0298",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2782 26.8354V44.3049C37.2782 45.5172 36.2954 46.5 35.0831 46.5H4.35137C3.13902 46.5 2.15625 45.5172 2.15625 44.3049V3.69512C2.15625 2.48277 3.13902 1.5 4.35137 1.5H35.0831C36.2954 1.5 37.2782 2.48277 37.2782 3.69512V15.9512",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.619 20.5244H7.96045V16.8659H11.619V20.5244Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2471 20.5244H27.4574",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.619 30.0366H7.96045V26.3781H11.619V30.0366Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2471 30.0366H29.2948",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.619 39.5488H7.96045V35.8903H11.619V39.5488Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2471 39.5488H23.1015",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6522 13.6802L32.0906 35.4375L26.7598 39.5488L27.6549 32.8766L41.0968 9.59446C41.804 8.36959 43.3703 7.94986 44.5951 8.65705C45.82 9.36425 46.2397 10.9306 45.5325 12.1554L44.6522 13.6802Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.831 35.2875L27.7607 32.9376",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6523 13.6802L40.2166 11.1192",
    stroke: "#2F2F2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingQualityAssurance);
export default __webpack_public_path__ + "static/media/Testing&QualityAssurance.1b93a1a9d386d96c0e1d12cc1579155f.svg";
export { ForwardRef as ReactComponent };